import styled from 'styled-components'
import { MediumText, BoldText } from 'components/common/text'
import { Column } from 'components/common/layout'

export const SectionTitle = styled(BoldText)`
  margin-left: 4px;
  margin-bottom: 24px;
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.h5};
  }
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: ${(p) => p.theme.fontSize.h4};
  }
`

export const SubSectionTitle = styled(MediumText)`
  padding-left: 4px;
  font-size: ${(p) => p.theme.fontSize.h5};
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.desc};
  }
`

export const SectionPaper = styled(Column)`
  padding: 24px;
  border-radius: 12px;
  background-color: ${(p) => p.theme.color.background};
  @media ${(p) => p.theme.deviceSize.mobile} {
    padding: 16px;
  }
`

export const SubSectionWrapper = styled(Column)`
  gap: 8px;
`

export const NotFoundContent = styled(BoldText)`
  width: 100%;
  text-align: center;
  color: ${(p) => p.theme.color.gray2};
  font-size: ${(p) => p.theme.fontSize.h5};
`
